import React from 'react';
import PropTypes from 'prop-types';
import {Helmet} from 'react-helmet';
import {Card, CardHeader, List, Paper} from '@material-ui/core';
import CustomiseProjectToolbar from 'CustomiseProject/presentation/CustomiseProjectToolbar';
import MilestoneProcedureList from 'CustomiseProject/presentation/MilestoneProcedureList';

function CustomiseProject(props) {
  const {importedProject, onToggleEnableProcedure, onToggleEnableMilestone, milestones} = props;

  return (
    <Paper>
      <Helmet title={importedProject.cnsObject.name} defer={false} />
      <CustomiseProjectToolbar {...props} />
      <Card>
        <CardHeader subheader="Toggle the milestone or procedure to display or hide them. Toggle ON means it will be displayed to the client" />
      </Card>

      {milestones.map((eachMilestone) => (
        <List key={eachMilestone.milestone.id}>
          <MilestoneProcedureList
            milestone={eachMilestone}
            importedProject={importedProject}
            onToggleEnableProcedure={onToggleEnableProcedure}
            onToggleEnableMilestone={onToggleEnableMilestone}
          />
        </List>
      ))}
    </Paper>
  );
}

CustomiseProject.propTypes = {
  importedProject: PropTypes.shape({
    cnsObject: PropTypes.shape({
      name: PropTypes.string.isRequired,
    }).isRequired,
  }).isRequired,
  milestones: PropTypes.array.isRequired,
  onToggleEnableProcedure: PropTypes.func.isRequired,
  onToggleEnableMilestone: PropTypes.func.isRequired,
};

export default CustomiseProject;
